import React from "react";
import AdmFeeReport from "../../components/AdminTabs/AdminFeeReport/AdmFeeReport";

const FeeReport = () => {
  return <AdmFeeReport />;
};

export default FeeReport;
